import { render, staticRenderFns } from "./kreditirahoitus.vue?vue&type=template&id=6283c542&"
import script from "./kreditirahoitus.vue?vue&type=script&lang=js&"
export * from "./kreditirahoitus.vue?vue&type=script&lang=js&"
import style0 from "./kreditirahoitus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports